import { create } from 'zustand';

interface RouteHistoryState {
  history: string[];
  addRoute: (route: string) => void;
}

export const useRouteHistory = create<RouteHistoryState>((set) => ({
  history: [],
  addRoute: (route) =>
    set((state) => {
      // Don't add if the new route is the same as the last one
      if (state.history[state.history.length - 1] === route) {
        return state;
      }
      return {
        history: [...state.history, route],
      };
    }),
}));
